module.exports = __webpack_public_path__ + "img/EN-Funded-by-the-EU-POS.c858684c.jpg";